function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
var logos = {
  '000': require('@/assets/icons/logo_000.png'),
  '002': require('@/assets/icons/logo_002.png'),
  '003': require('@/assets/icons/logo_003.png'),
  '004': require('@/assets/icons/logo_004.png'),
  '005': require('@/assets/icons/logo_005.png'),
  '010': require('@/assets/icons/logo_010.png'),
  '011': require('@/assets/icons/logo_011.png'),
  '012': require('@/assets/icons/logo_012.png'),
  '013': require('@/assets/icons/logo_013.png'),
  '014': require('@/assets/icons/logo_014.png'),
  '015': require('@/assets/icons/logo_015.png'),
  '019': require('@/assets/icons/logo_019.png'),
  '021': require('@/assets/icons/logo_021.png'),
  '021001': require('@/assets/icons/logo_021001.png'),
  '022': require('@/assets/icons/logo_022.png'),
  '024': require('@/assets/icons/logo_024.png'),
  '032': require('@/assets/icons/logo_032.png'),
  '033': require('@/assets/icons/logo_033.png'),
  '038': require('@/assets/icons/logo_038.png'),
  '041': require('@/assets/icons/logo_041.png'),
  '044': require('@/assets/icons/logo_044.png'),
  '059': require('@/assets/icons/logo_059.png'),
  '061': require('@/assets/icons/logo_061.png'),
  '064': require('@/assets/icons/logo_064.png'),
  '074': require('@/assets/icons/logo_074.png'),
  '086': require('@/assets/icons/logo_086.png'),
  '091': require('@/assets/icons/logo_091.png'),
  '092': require('@/assets/icons/logo_092.png'),
  '7777': require('@/assets/icons/Corporativos.png')
};
export default {
  name: 'IncaMetrics',
  data: function data() {
    return {
      list_orgs: [],
      isLoading: false,
      selectedOption: 'current_month',
      dateOptions: [{
        text: 'Últimos 30 días',
        value: 'current_month'
      }, {
        text: 'Últimos 90 días',
        value: 'last_3_months'
      }, {
        text: 'Últimos 180 días',
        value: 'last_6_months'
      }, {
        text: 'Últimos 365 días',
        value: 'last_year'
      }],
      selectedModule: 'data_management',
      moduleOptions: [{
        text: 'Gestión de datos',
        value: 'data_management'
      }, {
        text: 'Marketplace de atributos',
        value: 'attribute_marketplace'
      }, {
        text: 'Audiencias digitales',
        value: 'digital_audiences'
      }, {
        text: 'Conocimiento al cliente',
        value: 'customer_insights'
      }],
      first_list: [],
      second_list: [],
      first_title: 'Top 5 Empresas con más objetos publicados.',
      second_title: 'Top 5 Empresas con más solicitudes de acceso.',
      logos: logos
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.loadOrganizationDetails();
          case 1:
            this.loadInfo();
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  computed: {
    start_date: function start_date() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      switch (this.selectedOption) {
        case 'current_month':
          return new Date(today.setDate(today.getDate() - 30));
        case 'last_3_months':
          return new Date(today.setDate(today.getDate() - 90));
        case 'last_6_months':
          return new Date(today.setDate(today.getDate() - 180));
        case 'last_year':
          return new Date(today.setDate(today.getDate() - 365));
        default:
          return null;
      }
    },
    end_date: function end_date() {
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return end;
    }
  },
  methods: {
    loadOrganizationDetails: function () {
      var _loadOrganizationDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.isLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return domainService.getOrganizationsDetail();
            case 2:
              response = _context2.v;
              if (response.success) {
                this.list_orgs = response.data;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error(_t);
            case 4:
              _context2.p = 4;
              this.isLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function loadOrganizationDetails() {
        return _loadOrganizationDetails.apply(this, arguments);
      }
      return loadOrganizationDetails;
    }(),
    loadInfo: function () {
      var _loadInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        var params, response, _t2, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.isLoading = true;
              _t2 = this.selectedModule;
              _context3.n = _t2 === 'data_management' ? 1 : _t2 === 'attribute_marketplace' ? 2 : _t2 === 'digital_audiences' ? 3 : _t2 === 'customer_insights' ? 4 : 5;
              break;
            case 1:
              this.first_title = 'Top 5 Empresas con más objetos publicados.';
              this.second_title = 'Top 5 Empresas con más solicitudes de acceso.';
              return _context3.a(3, 6);
            case 2:
              this.first_title = 'Top 5 Empresas con más sandboxes creados.';
              this.second_title = 'Top 5 Empresas con más segmentos exportados.';
              return _context3.a(3, 6);
            case 3:
              this.first_title = 'Top 5 Empresas con más audiencias creadas.';
              this.second_title = 'Top 5 Empresas con más ingresos por audiencias.';
              return _context3.a(3, 6);
            case 4:
              this.first_title = 'Top 5 más dataentries cargados.';
              this.second_title = '';
              return _context3.a(3, 6);
            case 5:
              return _context3.a(3, 6);
            case 6:
              _context3.p = 6;
              params = {
                'start_date': this.start_date,
                'end_date': this.end_date,
                'module': this.selectedModule
              };
              _context3.n = 7;
              return MonitoringAccessService.incaMetrics(params);
            case 7:
              response = _context3.v;
              console.log(response);
              this.first_list = response.data.first_list;
              this.second_list = response.data.second_list;
              this.first_list.forEach(function (item) {
                item.percentage = Math.round(item.percentage);
                item.company_name = _this.list_orgs.find(function (org) {
                  return org.code === item.business_code;
                }).alias;
              });
              this.second_list.forEach(function (item) {
                item.percentage = Math.round(item.percentage);
                item.company_name = _this.list_orgs.find(function (org) {
                  return org.code === item.business_code;
                }).alias;
              });
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t3 = _context3.v;
              console.error(_t3);
            case 9:
              _context3.p = 9;
              this.isLoading = false;
              return _context3.f(9);
            case 10:
              return _context3.a(2);
          }
        }, _callee3, this, [[6, 8, 9, 10]]);
      }));
      function loadInfo() {
        return _loadInfo.apply(this, arguments);
      }
      return loadInfo;
    }(),
    calculateLogoPath: function calculateLogoPath(companyCode) {
      if (!this.logos[companyCode]) {
        return require('@/assets/icons/Corporativos.png');
      }
      return this.logos[companyCode];
    }
  }
};